import React, {Component, PropTypes} from 'react';

const withSelected = WrappedComponent => {
  return React.createClass({
    getInitialState: function() {
      return {
        selected: this.props.selected
      };
    },

    // componentDidMount: function() {
    //       // ... that takes care of the subscription...
    //       console.log(this.props)
    //     },

    render: function() {
      const newProps = {
        clickHandler: (data) => {
          // console.log('From HOC')
          this.props.clickHandler(data);
          this.setState({
            selected: this.state.selected && this.state.selected.key === data.key? null : {key: data.key}
          });
        },
        selected: this.state.selected
      };

      // Use JSX spread syntax to pass all props and state down automatically.
      return <WrappedComponent {...this.props} {...newProps}/>;
    }
  });
};

export default withSelected;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/hoc/withSelected.js